module.exports = __webpack_public_path__ + "img/hr-destroyer-robot.109336d4.png";